import { render, staticRenderFns } from "./SeeIssueDialog.vue?vue&type=template&id=5955d21c&scoped=true"
import script from "./SeeIssueDialog.vue?vue&type=script&lang=ts"
export * from "./SeeIssueDialog.vue?vue&type=script&lang=ts"
import style0 from "./SeeIssueDialog.vue?vue&type=style&index=0&id=5955d21c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5955d21c",
  null
  
)

export default component.exports